import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import Store from "../../components/contracts/AddContract";
import ItemList from "../../components/contracts/ItemList";
import Cart from "../../components/contracts/Cart";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const Contracts = () => {
  const [show, setShow] = useState(true);
  const [cart, setCart] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  
  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin") {
      navigate("/dashboard");
    }
  }, [isError, navigate]);

  const handleClick = (item) => {
    if (window.confirm('Add to contract this item?')) {
      if (cart.indexOf(item) !== -1) return;
      setCart([...cart, item]);
      setShow(false);
    }else{
      return
    }
  };

  const handleChange = (item, d) => {
    const ind = cart.indexOf(item);
    const arr = cart;
    arr[ind].amount += d;

    if (arr[ind].amount === 0) arr[ind].amount = 1;
    setCart([...arr]);
  };
  return (
    <Layout>
      <Store setShow={setShow} size={cart.length} />
      {show ? (
        <ItemList handleClick={handleClick} />
      ) : (
        <Cart cart={cart} setCart={setCart} handleChange={handleChange} />
      )}
    </Layout>
  );
};

export default Contracts;
